<div class="container change-password-container">
    <div class="p-4">
        <form #formGroup="ngForm">
            <div class="d-flex align-items-center justify-content-between">
                <h2>{{ 'ChangePassword.CHANGE_PASSWORD' | translate }}</h2>
            </div>
            <div class="row g-3 my-3 w-100 justify-content-center">
                <div class="col-12 col-md-8">
                    <mat-form-field class="col-12" appearance="outline">
                        <div class="d-flex col-12 align-items-center justify-content-between">
                            <input placeholder="{{ 'ChangePassword.OLD_PASSWORD' | translate }}" [pattern]="validPasswordPattern" 
                                   [type]="hideOldPassword ? 'password' : 'text'" autocomplete="off" matInput required 
                                   id="oldPasswordRef" class="form-control" name="oldPasswordRef" [(ngModel)]="oldPassword" 
                                   #oldPasswordRef="ngModel" minlength="8">                       
                            <button class="show_password" id="btn_show_password" mat-icon-button matSuffix
                                    (click)="hideOldPassword = !hideOldPassword" [attr.aria-label]="'Hide password'" 
                                    [attr.aria-pressed]="hideOldPassword">
                                <i class="ri-{{hideOldPassword ? 'eye-off-line' : 'eye-line'}}"></i>
                            </button>
                        </div>
                        <mat-error *ngIf="oldPasswordRef.errors?.['required']">{{ 'ChangePassword.REQUIRED' | translate }}</mat-error>
                        <mat-error *ngIf="oldPasswordRef.errors?.['pattern']">{{ 'ChangePassword.PASSWORD_CRITERIA' | translate }}</mat-error>
                        <mat-error *ngIf="oldPasswordRef.errors?.['minlength']">{{ 'ChangePassword.MIN_PASSWORD_LENGTH' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-8">
                    <mat-form-field class="col-12" appearance="outline">
                        <div class="d-flex col-12 align-items-center justify-content-between">
                            <input placeholder="{{ 'ChangePassword.NEW_PASSWORD' | translate }}" [pattern]="validPasswordPattern" 
                                   [type]="hideNewPassword ? 'password' : 'text'" autocomplete="off" matInput required 
                                   id="newPasswordRef" class="form-control" name="newPasswordRef" [(ngModel)]="newPassword" 
                                   #newPasswordRef="ngModel" minlength="8">                       
                            <button class="show_password" id="btn_show_password" mat-icon-button matSuffix
                                    (click)="hideNewPassword = !hideNewPassword" [attr.aria-label]="'Hide password'" 
                                    [attr.aria-pressed]="hideNewPassword">
                                <i class="ri-{{hideNewPassword ? 'eye-off-line' : 'eye-line'}}"></i>
                            </button>
                        </div>
                        <mat-error *ngIf="newPasswordRef.errors?.['required']">{{ 'ChangePassword.REQUIRED' | translate }}</mat-error>
                        <mat-error *ngIf="newPasswordRef.errors?.['pattern']">{{ 'ChangePassword.PASSWORD_CRITERIA' | translate }}</mat-error>
                        <mat-error *ngIf="newPasswordRef.errors?.['minlength']">{{ 'ChangePassword.MIN_PASSWORD_LENGTH' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-8">
                    <mat-form-field class="col-12" appearance="outline">
                        <div class="d-flex col-12 align-items-center justify-content-between">
                            <input placeholder="{{ 'ChangePassword.CONFIRM_NEW_PASSWORD' | translate }}" [pattern]="validPasswordPattern" 
                                   [type]="hideConfirmNPassword ? 'password' : 'text'" autocomplete="off" matInput required 
                                   id="confirmNewPasswordRef" class="form-control" name="confirmNewPasswordRef" 
                                   [(ngModel)]="confirmNewPassword" #confirmNewPasswordRef="ngModel" minlength="8">                       
                            <button class="show_password" id="btn_show_password" mat-icon-button matSuffix
                                    (click)="hideConfirmNPassword = !hideConfirmNPassword" [attr.aria-label]="'Hide password'" 
                                    [attr.aria-pressed]="hideConfirmNPassword">
                                <i class="ri-{{hideConfirmNPassword ? 'eye-off-line' : 'eye-line'}}"></i>
                            </button>
                        </div>
                        <mat-error *ngIf="confirmNewPasswordRef.errors?.['required']">{{ 'ChangePassword.REQUIRED' | translate }}</mat-error>
                    </mat-form-field>
                    <mat-hint *ngIf="newPassword && confirmNewPassword && !isPasswordIdentical()" class="color-red font-weight-700 font-size-3">
                        {{ 'ChangePassword.PASSWORD_MISMATCH' | translate }}
                    </mat-hint>
                </div>
                <button class="col-12 col-md-8 add-btn primary-btn my-3 py-2" 
                        [disabled]="formGroup.invalid || !isPasswordIdentical()" 
                        (click)="changePassword()">{{ 'ChangePassword.SUBMIT' | translate }}</button>
            </div>
        </form>
    </div>
</div>

